import { API_BASE_URL } from "../../../configurations/configurations";
import { mainApiSlice } from "../api/mainApiSlice";

export const orderApi = mainApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createNewOrder: builder.mutation({
      query: ({ order_details }) => ({
        url: `${API_BASE_URL}/orders/create-order`,
        method: "POST",
        body: order_details,
        headers: {
          "Content-Type": "application/json",
        },
      }),
    }),

    captureOrder: builder.mutation({
      query: ({ orderId, userId }) => ({
        url: `${API_BASE_URL}/orders/capture-order/${orderId}/${userId}`,
        method: "POST",
      }),
    }),
  }),
});

export const {
  useCreateNewOrderMutation,
  useCaptureOrderMutation,
  useCompleteOrderMutation,
} = orderApi;
